import { render, staticRenderFns } from "./industryData.vue?vue&type=template&id=37852045&scoped=true&"
import script from "./industryData.vue?vue&type=script&lang=js&"
export * from "./industryData.vue?vue&type=script&lang=js&"
import style0 from "./industryData.vue?vue&type=style&index=0&id=37852045&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37852045",
  null
  
)

export default component.exports